import { NgModule } from '@angular/core';

import { AuthGuard } from './auth.guard';

import { SharedModule } from '@mem-shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationInterceptor } from './auth-interceptor';
import { FetchUserDataComponent } from './fetch-user-data/fetch-user-data.component';
import { MemberAccountDetailsResolver } from './member-account-details-resolver.service';

@NgModule({
  imports: [SharedModule],
  declarations: [FetchUserDataComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    AuthGuard,
    MemberAccountDetailsResolver
  ]
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts